import { render, staticRenderFns } from "./app-notes-modal.vue?vue&type=template&id=39b27b55"
import script from "./app-notes-modal.vue?vue&type=script&lang=ts"
export * from "./app-notes-modal.vue?vue&type=script&lang=ts"
import style0 from "./app-notes-modal.vue?vue&type=style&index=0&id=39b27b55&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39b27b55')) {
      api.createRecord('39b27b55', component.options)
    } else {
      api.reload('39b27b55', component.options)
    }
    module.hot.accept("./app-notes-modal.vue?vue&type=template&id=39b27b55", function () {
      api.rerender('39b27b55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-notes-modal/app-notes-modal.vue"
export default component.exports